<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :dense="dense"
            :multiple="multiple"
            :selectAll="selectAll"
            :auto-complete="autoComplete"
            :item-text="itemText"
            :disabled="disabled"
        />
        <sys-register-branch @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectBranch',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        if(this.onlyWithCompany && !this.companyId){
            return;
        }

        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        dense: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        selectAll: {
            type: Boolean,
            default: false
        },
        itemText: {
            type: String,
            default: 'name'
        },
        companyId: {

        },
        campusId: {

        },
        onlyWithCompany: {
            type: Boolean,
            default: false,
        },
        clearOnCompanyChange: {
            type: Boolean,
            default: false,
        }
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        companyId(val, oldVal){
            if(this.onlyWithCompany && !val){
                this.items = [];
                this.selected = null;
                return;
            }

            if(this.clearOnCompanyChange && val !== oldVal){
                this.selected = null;
            }

            this.getItems();
        },

        campusId(val){
            this.getItems();
        },
        
    },
    methods: {
        ...mapActions('paymentExport', ['ActionIndexBranches']),        
        
        async getItems() {

            if(this.onlyWithCompany && !this.companyId){
                this.items = [];
                this.loading = false;
                return;
            }

            this.loading = true;

            var payload = {
                column_order: 'name',
            };

            if(this.companyId){
                payload.find_columns = {
                    company_id: this.companyId
                }
            }

            if(this.campusId){
                payload.filter_relations = [
                    {
                        name:   'campuses',
                        key:    'campus_id',
                        value:  this.campusId
                       
                    }
                ];
            }

            await this.ActionIndexBranches(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

    newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>
